
import { FieldArray, getIn } from "formik";
import { Col, Form, Row, Table } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash';

const VehicleRentalCompanies = ({ values, errors, touched, setFieldValue, hideSectionLabel = true }) => {
  const { t } = useTranslation()

  const renderFieldError = (fieldName: string) => {
    const error = getIn(errors, fieldName);

    if (error) {
      return (
        <small className="text-danger">
          {error}
        </small>
      )
    }

    return null;
  }

  return (
    <div className="mt-2">

      {hideSectionLabel ? null : <Form.Label>{t('rental_companies')}</Form.Label>}

      <FieldArray name="lista_noleggiatori_quotatore">
        {() => (
          <>
            <Table responsive="md">
              <thead>
                <tr>
                  <th>{t('rental_company')}</th>
                  <th>
                    <Row>

                      <Col md={3}></Col>
                      <Col md={9}>
                        {t('extra_discount_adjustment')}

                      </Col>
                    </Row>
                  </th>
                </tr>
              </thead>
              <tbody>
                {(values.lista_noleggiatori_quotatore || []).map((item: any, idx: number) => (
                  <tr key={idx}>
                    <td style={{ width: '50%' }}>
                      <Form.Group >
                        <Form.Check
                          type="checkbox"
                          id={`checkbox-${item.noleggiatore}`}
                          label={item.noleggiatore}
                          checked={item.is_checked}
                          onChange={(e) => setFieldValue(`lista_noleggiatori_quotatore.${idx}.is_checked`, e.target.checked)}
                        />
                      </Form.Group>
                    </td>
                    <td style={{ width: '50%' }}>
                      <Form.Group>
                        <Form.Control
                          value={isNil(item.extra_sconto_perc) ? '' : item.extra_sconto_perc}
                          type="text"
                          onChange={(e) => {
                            setFieldValue(`lista_noleggiatori_quotatore.${idx}.extra_sconto_perc`, e.target.value)
                          }}
                          name={`lista_noleggiatori_quotatore.${idx}.extra_sconto_perc`}
                        />
                        {renderFieldError(`lista_noleggiatori_quotatore.${idx}.extra_sconto_perc`)}
                      </Form.Group>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </FieldArray>
    </div>
  )
}

export default VehicleRentalCompanies;
